import { LANGUAGE_CODE_TO_NAME } from '../../constants'

// Resolve a stored language code to the full name the backend expects.
// Falls back to `english` for any unknown / missing value, and is
// idempotent — passing the full name back through returns it unchanged.
export function resolveLanguageName(code) {
  if (!code) return 'english'
  const lower = String(code).toLowerCase()
  if (Object.prototype.hasOwnProperty.call(LANGUAGE_CODE_TO_NAME, lower)) {
    return LANGUAGE_CODE_TO_NAME[lower]
  }
  return 'english'
}
